export const createRoute = (builder) => ({
    createRoute: builder.mutation({
        query: (payload) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/create_route',
                method: 'POST',
                body: payload,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});